export function accountIsBillable(account: any): boolean {
    return (
        !!account &&
        !!account.billing_data &&
        account.billing_data.type === 'CREDIT' &&
        !!account.billing_data.stripe_customer_id
    )
}
